<template>
  <Intro :use-slot1="true"
         :use-slot2="true"
         :use-slot3="true"
         :partner-name="partnerName"
         particle="은">
    <!-- Slot1 -->
    <template v-slot:slot1>
      <div class="xl-flex-row xl-center" style="width: 100%; height: 60px; font-size: 46px; font-weight: 800">
        <div style="color: #3497fd">최대 연 12%까지</div>
      </div>
    </template>
    <!-- Slot2 -->
    <template v-slot:slot2>
      <div class="xl-flex-row xl-center" style="height: 100%; color: #ffffff; font-weight: 600">
        <span style="font-size: 48px; font-weight: 800">{{partnerName}}</span>
        <div class="_h_Padding_" style="width: 3px"></div>
        <span style="font-size: 42px; font-weight: 400; margin-top: 10px">에서</span>
      </div>
    </template>
    <template v-slot:slot2_760>
      <div class="xl-flex-row xl-center" style="height: 100%; color: #ffffff; font-weight: 600">
        <span style="font-size: 42px; font-weight: 800">{{partnerName}}</span>
        <div class="_h_Padding_" style="width: 3px"></div>
        <span style="font-size: 34px; font-weight: 400; margin-top: 10px">에서</span>
      </div>
    </template>
    <template v-slot:slot2_360>
      <div class="xl-flex-row xl-center" style="height: 100%; color: #ffffff; font-weight: 600">
        <span style="font-size: 27px; font-weight: 800">{{partnerName}}</span>
        <div class="_h_Padding_" style="width: 3px"></div>
        <span style="font-size: 19px; font-weight: 400; margin-top: 10px">에서</span>
      </div>
    </template>
    <!-- Slot3-->
    <template v-slot:slot3>
      <div class="xl-flex-row xl-center">
        <div style="color: #3497fd; font-weight: 800"></div>
        <div>&nbsp;4대보험료 절감 절차</div>
      </div>
    </template>
  </Intro>
</template>
<script>
import Intro from '../../../components/page/services/insurance/intro'
export default {
  layout: 'ifs2',
  components:{Intro},
  created() {
    const partnerInfo = this.$getPartnerInfo();
    if(process.client){
      this.partnerName = partnerInfo.serviceName;
    }
  },
  mounted() {
    // popup control
    const landing = this.$route.params.landing;
    if ( landing == 'mainbiz' ) {
      const popupStop = this.$popupCtrlP_didStopReq('popupMainBiz');
      if ( !popupStop ) {
        this.$store.dispatch('ui/togglePopup','popupMainBiz')
      }
    }
  },
  data(){
    return {
      partnerName:null
    }
  }
}
</script>
